import { render, staticRenderFns } from "./ModalAnaliseElegibilidadeRelatorio.vue?vue&type=template&id=52f58852&lang=pug"
import script from "./ModalAnaliseElegibilidadeRelatorio.vue?vue&type=script&lang=js"
export * from "./ModalAnaliseElegibilidadeRelatorio.vue?vue&type=script&lang=js"
import style0 from "./ModalAnaliseElegibilidadeRelatorio.vue?vue&type=style&index=0&id=52f58852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports